import { getPartnerType } from "@src/api/partner/partner";
import { HOSTNAME, isExternalUrl } from "@src/utils";
import QueryString from "qs";

interface PartnerRouteOption {
  partnerType?: number;
  query?: Object;
}

export async function getPartnerDetailUrl(uuid: string, option?: PartnerRouteOption) {
  const { partnerType, query } = option || {};

  let queryString = "";
  if (query) {
    queryString = `?${QueryString.stringify(query)}`;
  }

  // partnerType이 2면 웨딩홀 페이지로
  if (partnerType === 2) {
    return getWeddingHallDetailUrl(uuid, queryString);
  }

  // partnerType이 undefined가 아니고 2가 아닌 경우 웨딩홀 외 업체페이지로
  if (partnerType !== undefined && partnerType !== 2) {
    return getOtherPartnerDetailUrl(uuid, queryString);
  }

  // partnerType이 undefined인 경우, 즉 잘 모를 경우 api를 통해 가져옴
  try {
    const resData = await getPartnerType(uuid);
    if (resData.data.item === 2) {
      return getWeddingHallDetailUrl(uuid, queryString);
    } else {
      return getOtherPartnerDetailUrl(uuid, queryString);
    }
  } catch (error) {
    console.error("getPartnerDetailUrl", error);
    return getOtherPartnerDetailUrl(uuid, queryString);
  }
}

function getWeddingHallDetailUrl(uuid: string, queryString: string) {
  const weddingHallDetailUrl = `${HOSTNAME}/weddinghall/${uuid}${queryString}`;
  return isExternalUrl(weddingHallDetailUrl);
}

function getOtherPartnerDetailUrl(uuid: string, queryString: string) {
  const partnerDetailUrl = `${HOSTNAME}/partner/${uuid}${queryString}`;
  return isExternalUrl(partnerDetailUrl);
}

export function closeWebview() {
  window.location.href = "h2mwbell://webview/close";
}

export function goWebviewHome() {
  window.location.href = "h2mwbell://home";
}
